<template>
  <div
    :class="{[getCss('default')]: !styles.image || !styles.image.src , 'csu-clickable': clickable}"
    :style="styles.base"
    @click="handleClickEvent()"
    @mouseenter="handleEvent('hover')"
  >
    <img
      v-if="styles.image.src"
      :class="[styles.image.equalScale ? getCss('contain') : getCss('fill')]"
      v-src="styles.image.src"
      width="100%"
      height="100%"
      :alt="styles.image.alt"
    >
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
export default {
  name: 'CImage',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'image-',
      classKeys: [
        'default',
        'contain',
        'fill',
      ],
    };
  },
  methods: {
  },
};
</script>
<style lang="scss">
  @import './image.scss';
</style>
